import React from "react";
import "./App.css";
import Router from "./Router";
import { SnackbarProvider } from "notistack";
import ScrollToTop from "./components/ScrollToTop";
import TitleManager from "./components/TitleManager";
import CookieConsent from "./components/CookieConsent";


function App() {
  return (
    <SnackbarProvider>      
        <ScrollToTop />
        <TitleManager />
        <Router />
        <CookieConsent />      
    </SnackbarProvider>
  );
}

export default App;
